import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { FormInfoService } from '../services/dynamic-forms/form-info.service';
import { IDynamicFormGroupDefinition } from '../models/dynamic-form-group';

// Sets the FormGroupDefinition to be used within this form's scope
@Directive({
  selector: '[dynamicFormInfo]',
  providers: [FormInfoService],
     
})
export class DynamicFormLoadDirective {
  private viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<any>,{optional:true});

  formInfo: IDynamicFormGroupDefinition;


  @Input() set dynamicFormInfo(formInfo: IDynamicFormGroupDefinition) {
    this.formInfo = formInfo;
    if (this.formInfo == null) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
